(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
       
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

   class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function recommendationsSlider() {
    $('.product-recommendations .product-recommendations-grid.owl-carousel').owlCarousel({
          loop: !0,
          nav: !0,
          dots: !1,
          autoplay: !1,
          responsive:{
            0:{
              items:1
            },
            320:{
              items:2
            },
            575:{
              items:3
            },
            750:{
              items:3
            },
            990:{
              items:4
            },
            1249:{
              items:5
            },
            1499:{
              items:6
            }
        }
      });
  }
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
			if (html.querySelector('.product-recommendations .grid__item')) {
                this.classList.add('product-recommendations--loaded');			  
             	initButtons();
                initButtonsCompare();
            }
            recommendationsSlider();
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 3000px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solis-configurator"] && !Shopify.designMode) return;
  try {
    
(() => {
function createSelection(config) {
  return { tire: config.default_tire, loader: 'none', lift: 'none', cabin: Boolean(config.factory_cabin), extras: new Set() };
}

function automaticWeight(config, state) {
  return Boolean(config.counterweight) && (config.weight_tires || ['162']).includes(state.tire) && state.loader !== 'none';
}

function ids(config, state) {
  const result = new Set(state.extras);
  result.add(state.tire);
  if (state.loader !== 'none') result.add(state.loader);
  if (state.lift !== 'none') result.add(state.lift);
  if (state.cabin && config.cabin) result.add(config.cabin);
  if (automaticWeight(config, state)) result.add(config.counterweight);
  return result;
}

function allowed(config, option, state) {
  const byId = new Map(config.options.map(item => [item.id, item]));
  if (option.role === 'loader_extra' && byId.get(state.loader)?.brand !== option.brand) return false;
  if (option.role === 'cabin_extra' && !state.cabin) return false;
  if (option.role === 'lift_extra' && byId.get(state.lift)?.brand !== option.brand) return false;
  if (option.requires_cabin !== undefined && state.cabin !== option.requires_cabin) return false;
  if (option.hide_when_loader_includes && byId.get(state.loader)?.label.toLowerCase().includes(option.hide_when_loader_includes.toLowerCase())) return false;
  const selected = ids(config, state);
  if (option.requires_option && !selected.has(option.requires_option)) return false;
  if (option.requires_any && !option.requires_any.some(id => selected.has(id))) return false;
  return true;
}

function normalize(config, value) {
  const state = { ...value, extras: new Set(value.extras) };
  const byId = new Map(config.options.map(item => [item.id, item]));
  if (byId.get(state.tire)?.role !== 'tire') state.tire = config.default_tire;
  if (byId.get(state.loader)?.role !== 'loader') state.loader = 'none';
  if (byId.get(state.lift)?.role !== 'front_lift') state.lift = 'none';
  if (config.factory_cabin) state.cabin = true;
  if (!config.factory_cabin && !config.cabin) state.cabin = false;
  for (const kind of ['loader', 'lift']) {
    const option = byId.get(state[kind]);
    if (option && !allowed(config, option, state)) state[kind] = 'none';
  }
  for (let pass = 0; pass < 3; pass += 1) {
    for (const id of state.extras) {
      const option = byId.get(id);
      if (!option || !allowed(config, option, state)) state.extras.delete(id);
    }
  }
  return state;
}

function changeSelection(config, previous, kind, value, checked = true) {
  const state = { ...previous, extras: new Set(previous.extras) };
  if (kind === 'tire' || kind === 'loader' || kind === 'lift') state[kind] = value;
  if (kind === 'cabin') state.cabin = checked;
  if (kind === 'extra') {
    const option = config.options.find(item => item.id === value);
    if (option && checked && allowed(config, option, state)) {
      if (option.exclusive) {
        for (const id of state.extras) {
          if (config.options.find(item => item.id === id)?.exclusive === option.exclusive) state.extras.delete(id);
        }
      }
      state.extras.add(value);
    } else state.extras.delete(value);
  }
  return normalize(config, state);
}

function calculate(config, previous) {
  const state = normalize(config, previous);
  const selectedIds = ids(config, state);
  const selected = config.options.filter(option => selectedIds.has(option.id));
  const feeCents = config.fees.reduce((sum, fee) => sum + fee.cents, 0);
  const optionCents = selected.reduce((sum, option) => sum + option.cents, 0);
  return { state, selected, baseCents: config.base_cents, feeCents, optionCents, totalCents: config.base_cents + feeCents + optionCents, requiredWeight: automaticWeight(config, state) };
}


class SolisConfigurator extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.config = JSON.parse(this.querySelector('[data-config]').textContent);
    const livePrices = JSON.parse(this.querySelector('[data-live-prices]').textContent);
    const fees = this.config.fees.reduce((sum, fee) => sum + fee.cents, 0);
    const modelHandle = this.config.handle || 'solis-26-hst';
    if (Number.isSafeInteger(livePrices[modelHandle]) && livePrices[modelHandle] >= fees) this.config.base_cents = livePrices[modelHandle] - fees;
    this.config.options.forEach(option => {
      if (Number.isSafeInteger(livePrices[option.handle])) option.cents = livePrices[option.handle];
    });
    this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
    this.state = createSelection(this.config);
    this.preview = this.dataset.preview === 'true';
    this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style: 'currency', currency: this.config.currency});
    this.form = this.querySelector('[data-inquiry-form]');
    this.addEventListener('change', event => {
      const input = event.target.closest('[data-kind]');
      if (!input) return;
      this.state = changeSelection(this.config, this.state, input.dataset.kind, input.value, input.checked);
      this.render();
    });
    this.querySelectorAll('[data-open-inquiry]').forEach(button => button.addEventListener('click', () => {
      const region = this.querySelector('[data-inquiry]');
      region.hidden = false;
      this.updateInquiry();
      region.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      this.form.querySelector('[name="contact[name]"]').focus({preventScroll: true});
    }));
    this.querySelector('[data-reset]').addEventListener('click', () => {
      this.state = createSelection(this.config);
      this.render();
    });
    this.form.addEventListener('submit', event => {
      this.updateInquiry();
      if (this.preview) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.previewPrepared();
      }
    }, true);
    this.querySelector('[data-prepare]')?.addEventListener('click', () => {
      if (this.form.reportValidity()) this.previewPrepared();
    });
    this.render(false);
  }

  money(cents) {
    return this.formatter.format(cents / 100);
  }

  render(announce = true) {
    const result = calculate(this.config, this.state);
    this.state = result.state;
    this.result = result;
    this.querySelector('[data-base-price]').textContent = this.money(this.config.base_cents);
    this.querySelectorAll('[data-fee-price]').forEach(element => {
      const fee = this.config.fees.find(item => item.id === element.dataset.feePrice);
      element.textContent = this.money(fee.cents);
    });
    this.querySelectorAll('.sc-option').forEach(card => {
      const input = card.querySelector('input');
      const option = this.config.options.find(item => item.id === input.value);
      card.querySelector('.sc-option-price').textContent = option && option.cents > 0 ? '+ ' + this.money(option.cents) : this.labels.included;
    });
    const selected = new Set(result.selected.map(option => option.id));
    this.querySelectorAll('[data-kind]').forEach(input => {
      const kind = input.dataset.kind;
      if (kind === 'tire' || kind === 'loader' || kind === 'lift') input.checked = input.value === this.state[kind];
      else if (kind === 'cabin') input.checked = this.state.cabin;
      else {
        const option = this.config.options.find(item => item.id === input.value);
        input.checked = selected.has(input.value);
        input.disabled = !allowed(this.config, option, this.state) || (input.value === this.config.counterweight && result.requiredWeight);
        input.closest('.sc-option').classList.toggle('sc-option--disabled', input.disabled);
      }
      if ((kind === 'loader' || kind === 'lift') && input.value !== 'none') {
        const option = this.config.options.find(item => item.id === input.value);
        input.disabled = !allowed(this.config, option, this.state);
        input.closest('.sc-option').classList.toggle('sc-option--disabled', input.disabled);
      }
    });
    const loader = this.config.options.find(item => item.id === this.state.loader);
    const lift = this.config.options.find(item => item.id === this.state.lift);
    this.querySelectorAll('[data-loader-brand]').forEach(group => { group.hidden = group.dataset.loaderBrand !== loader?.brand; });
    this.querySelectorAll('[data-lift-brand]').forEach(group => { group.hidden = group.dataset.liftBrand !== lift?.brand; });
    this.querySelector('[data-loader-empty]').hidden = Boolean(loader);
    this.querySelector('[data-lift-empty]').hidden = Boolean(lift);
    this.querySelector('[data-cabin-extras]').hidden = !this.state.cabin;
    this.querySelector('[data-weight-note]').hidden = !result.requiredWeight;
    this.querySelector('[data-weight-caption]').hidden = !result.requiredWeight;
    this.querySelector('[data-loader-count]').textContent = loader ? loader.label.split(' ')[0] : this.labels.none;
    this.querySelectorAll('[data-total]').forEach(element => { element.textContent = this.money(result.totalCents); });
    this.querySelector('[data-options-total]').textContent = this.money(result.optionCents);
    const list = this.querySelector('[data-summary-options]');
    list.replaceChildren();
    const paid = result.selected.filter(option => option.cents > 0);
    if (!paid.length) {
      const empty = document.createElement('p');
      empty.className = 'sc-muted';
      empty.textContent = this.labels.standard_configuration;
      list.append(empty);
    }
    for (const option of paid) {
      const row = document.createElement('div');
      row.className = 'sc-summary-option';
      const label = document.createElement('span');
      label.textContent = option.label;
      const price = document.createElement('span');
      price.textContent = this.money(option.cents);
      row.append(label, price);
      list.append(row);
    }
    this.updateInquiry();
    if (announce) this.querySelector('[data-announcement]').textContent = `${this.labels.total}: ${this.money(result.totalCents)}${result.requiredWeight ? '. ' + this.labels.weight_auto : ''}`;
  }

  updateInquiry() {
    if (!this.result) return;
    const lines = [this.labels.inquiry_subject, this.config.model, '', `${this.labels.tractor}: ${this.money(this.config.base_cents)}`];
    this.config.fees.forEach(fee => lines.push(`${fee.label}: ${this.money(fee.cents)}`));
    lines.push('', this.labels.selected_equipment);
    this.result.selected.forEach(option => lines.push(`${option.label}: ${this.money(option.cents)}`));
    lines.push('', `${this.labels.total}: ${this.money(this.result.totalCents)}`, this.labels.price_note, this.labels.additional_costs, '', `${this.labels.source_date}: ${this.config.source_date}`);
    this.form.querySelector('[name="contact[body]"]').value = lines.join('\n');
  }

  previewPrepared() {
    this.updateInquiry();
    const feedback = this.querySelector('[data-preview-feedback]');
    feedback.hidden = false;
    feedback.textContent = this.labels.preview_prepared;
    feedback.focus();
  }
}

if (!customElements.get('solis-configurator')) customElements.define('solis-configurator', SolisConfigurator);

})();

  } catch(e) { console.error(e); }
})();
})();
